var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.5 191.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128c7e;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 95.75,
    cy: 95.75,
    r: 95.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.8,159.1c.53-2.38,1-4.58,1.52-6.77q5.11-22.77,10.24-45.55c.15-.67.34-1,1.14-1.08,5.18-.38,10.35-.84,15.52-1.27l15.22-1.26,15.44-1.28L129,100.46c2.08-.17,4.16-.33,6.24-.53.24,0,.46-.28.7-.43-.23-.12-.45-.35-.69-.36-3.81-.24-7.63-.44-11.45-.66l-17.56-1q-8.74-.49-17.49-1c-4.86-.27-9.72-.56-14.58-.84-2.77-.15-5.55-.33-8.33-.43-.75,0-1-.29-1.14-1-1.46-7.48-3-15-4.44-22.42L54.53,42.94c0-.19-.06-.38-.11-.74L172.09,99.05Z",
    transform: "translate(-4.8 -4.9)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.26e49793b99ccbdb4205e430839dae2f.svg";
export { ForwardRef as ReactComponent };